import React from 'react'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'
import { useFetchSubmissionVersionsQuery } from '../../../../../store/apis/submission.api'
import { DEFAULT_SUBMISSION_VERSION } from '../../../../../store/slices/submission.slice'
import { useParams } from 'react-router'
import SubmissionUnitTestResultsDetailed from './SubmissionUnitTestResultsDetailed'
import SubmissionUnitTestResultsSimplified from './SubmissionUnitTestResultsSimplified'

const SubmissionUnitTestResults = () => {
    const selectedVersionId = useSelector(submissionSelectors.selectedVersionId)
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)

    const { token, layerId } = useParams()

    const { data: submissionVersions } = useFetchSubmissionVersionsQuery(
        { token, layerId, submissionId: openedSubmissionId },
        { skip: selectedVersionId === DEFAULT_SUBMISSION_VERSION },
    )

    const selectedVersionIsTheLatest = submissionVersions?.at(-1).id === selectedVersionId

    if (!submissionVersions || selectedVersionIsTheLatest) {
        return <SubmissionUnitTestResultsDetailed />
    } else {
        return <SubmissionUnitTestResultsSimplified />
    }
}

export default SubmissionUnitTestResults
